import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Layout } from "../components/Layout";
import { useI18n } from "../i18n";
import * as apiClient from "../api";

export default function PaymentCancel() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const bn = localStorage.getItem("cristalda_pending_booking");
    const token = localStorage.getItem("cristalda_pending_token");
    if (bn && token) {
      apiClient.cancelPayment(bn, token).catch(() => {});
    }
    localStorage.removeItem("cristalda_pending_booking");
    localStorage.removeItem("cristalda_pending_token");
  }, []);

  return (
    <Layout>
      <div data-testid="payment-cancel-page" className="max-w-lg mx-auto px-4 py-24 text-center">
        <XCircle className="h-14 w-14 text-amber-500 mx-auto" />
        <h1 className="mt-6 text-2xl font-heading font-semibold text-slate-900">{t("payment.cancelled")}</h1>
        <p className="mt-2 text-slate-500">{t("payment.cancelleddesc")}</p>
        <button data-testid="payment-back-cart-btn" onClick={() => navigate("/vacanza")}
          className="mt-6 rounded-full bg-primary text-white font-semibold px-6 py-3 hover:bg-primary/90 transition-colors">
          {t("payment.backtocart")}
        </button>
      </div>
    </Layout>
  );
}
